import type { CostCenterDetail, LC_GetCostCenterByIdOut } from '../types';


export function mapCostCenterDetailFromTransport(
  transport: LC_GetCostCenterByIdOut,
): CostCenterDetail {
  return {
    id: transport.costCenterId,
    code: transport.costCenterCode,
    name: transport.costCenterName,
    description: transport.description,
    isEnabled: transport.isEnabled,
    createdDate: transport.createdDate,
    createdBy: transport.createdBy,
    modifiedDate: transport.modifiedDate || undefined,
    modifiedBy: transport.modifiedBy || undefined,
  };
}
